module.exports = __webpack_public_path__ + "static/newsletter-c1ca743b420c3deb31c64fb5ddd34677.png";